/* unplugin-vue-components disabled */import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "缓存列表", -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "键名列表", -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "缓存内容", -1);
import { listCacheName, listCacheKey, getCacheValue, clearCacheName, clearCacheKey, clearCacheAll } from "@/api/monitor/cache";
export default {
  __name: 'list',
  setup(__props) {
    const {
      proxy
    } = getCurrentInstance();
    const cacheNames = ref([]);
    const cacheKeys = ref([]);
    const cacheForm = ref({});
    const loading = ref(true);
    const subLoading = ref(false);
    const nowCacheName = ref("");
    const tableHeight = ref(window.innerHeight - 200);

    /** 查询缓存名称列表 */
    function getCacheNames() {
      loading.value = true;
      listCacheName().then(response => {
        cacheNames.value = response.data;
        loading.value = false;
      });
    }

    /** 刷新缓存名称列表 */
    function refreshCacheNames() {
      getCacheNames();
      proxy.$modal.msgSuccess("刷新缓存列表成功");
    }

    /** 清理指定名称缓存 */
    function handleClearCacheName(row) {
      clearCacheName(row.cacheName).then(response => {
        proxy.$modal.msgSuccess("清理缓存名称[" + nowCacheName.value + "]成功");
        getCacheKeys();
      });
    }

    /** 查询缓存键名列表 */
    function getCacheKeys(row) {
      const cacheName = row !== undefined ? row.cacheName : nowCacheName.value;
      if (cacheName === "") {
        return;
      }
      subLoading.value = true;
      listCacheKey(cacheName).then(response => {
        cacheKeys.value = response.data;
        subLoading.value = false;
        nowCacheName.value = cacheName;
      });
    }

    /** 刷新缓存键名列表 */
    function refreshCacheKeys() {
      getCacheKeys();
      proxy.$modal.msgSuccess("刷新键名列表成功");
    }

    /** 清理指定键名缓存 */
    function handleClearCacheKey(cacheKey) {
      clearCacheKey(cacheKey).then(response => {
        proxy.$modal.msgSuccess("清理缓存键名[" + cacheKey + "]成功");
        getCacheKeys();
      });
    }

    /** 列表前缀去除 */
    function nameFormatter(row) {
      return row.cacheName.replace(":", "");
    }

    /** 键名前缀去除 */
    function keyFormatter(cacheKey) {
      return cacheKey.replace(nowCacheName.value, "");
    }

    /** 查询缓存内容详细 */
    function handleCacheValue(cacheKey) {
      getCacheValue(nowCacheName.value, cacheKey).then(response => {
        cacheForm.value = response.data;
      });
    }

    /** 清理全部缓存 */
    function handleClearCacheAll() {
      clearCacheAll().then(response => {
        proxy.$modal.msgSuccess("清理全部缓存成功");
      });
    }
    getCacheNames();
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_row = _resolveComponent("el-row");
      const _component_el_form = _resolveComponent("el-form");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        gutter: 10
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, {
            style: {
              "height": "calc(100vh - 125px)"
            }
          }, {
            header: _withCtx(() => [_hoisted_2, _createVNode(_component_el_button, {
              style: {
                "float": "right",
                "padding": "3px 0"
              },
              type: "primary",
              link: "",
              icon: "Refresh",
              onClick: _cache[0] || (_cache[0] = $event => refreshCacheNames())
            })]),
            default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _unref(cacheNames),
              height: _unref(tableHeight),
              "highlight-current-row": "",
              onRowClick: getCacheKeys,
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                label: "序号",
                width: "60",
                type: "index"
              }), _createVNode(_component_el_table_column, {
                label: "缓存名称",
                align: "center",
                prop: "cacheName",
                "show-overflow-tooltip": true,
                formatter: nameFormatter
              }), _createVNode(_component_el_table_column, {
                label: "备注",
                align: "center",
                prop: "remark",
                "show-overflow-tooltip": true
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "60",
                align: "center",
                "class-name": "small-padding fixed-width"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_button, {
                  type: "primary",
                  link: "",
                  icon: "Delete",
                  onClick: $event => handleClearCacheName(scope.row)
                }, null, 8, ["onClick"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "height"])), [[_directive_loading, _unref(loading)]])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, {
            style: {
              "height": "calc(100vh - 125px)"
            }
          }, {
            header: _withCtx(() => [_hoisted_3, _createVNode(_component_el_button, {
              style: {
                "float": "right",
                "padding": "3px 0"
              },
              type: "primary",
              link: "",
              icon: "Refresh",
              onClick: _cache[1] || (_cache[1] = $event => refreshCacheKeys())
            })]),
            default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
              data: _unref(cacheKeys),
              height: _unref(tableHeight),
              "highlight-current-row": "",
              onRowClick: handleCacheValue,
              style: {
                "width": "100%"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_el_table_column, {
                label: "序号",
                width: "60",
                type: "index"
              }), _createVNode(_component_el_table_column, {
                label: "缓存键名",
                align: "center",
                "show-overflow-tooltip": true,
                formatter: keyFormatter
              }), _createVNode(_component_el_table_column, {
                label: "操作",
                width: "60",
                align: "center",
                "class-name": "small-padding fixed-width"
              }, {
                default: _withCtx(scope => [_createVNode(_component_el_button, {
                  type: "primary",
                  link: "",
                  icon: "Delete",
                  onClick: $event => handleClearCacheKey(scope.row)
                }, null, 8, ["onClick"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["data", "height"])), [[_directive_loading, _unref(subLoading)]])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          span: 8
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, {
            bordered: false,
            style: {
              "height": "calc(100vh - 125px)"
            }
          }, {
            header: _withCtx(() => [_hoisted_4, _createVNode(_component_el_button, {
              style: {
                "float": "right",
                "padding": "3px 0"
              },
              type: "primary",
              link: "",
              icon: "Refresh",
              onClick: _cache[2] || (_cache[2] = $event => handleClearCacheAll())
            }, {
              default: _withCtx(() => [_createTextVNode("清理全部")]),
              _: 1
            })]),
            default: _withCtx(() => [_createVNode(_component_el_form, {
              model: _unref(cacheForm)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_row, {
                gutter: 32
              }, {
                default: _withCtx(() => [_createVNode(_component_el_col, {
                  offset: 1,
                  span: 22
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "缓存名称:",
                    prop: "cacheName"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: _unref(cacheForm).cacheName,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(cacheForm).cacheName = $event),
                      readOnly: true
                    }, null, 8, ["modelValue"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  offset: 1,
                  span: 22
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "缓存键名:",
                    prop: "cacheKey"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: _unref(cacheForm).cacheKey,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(cacheForm).cacheKey = $event),
                      readOnly: true
                    }, null, 8, ["modelValue"])]),
                    _: 1
                  })]),
                  _: 1
                }), _createVNode(_component_el_col, {
                  offset: 1,
                  span: 22
                }, {
                  default: _withCtx(() => [_createVNode(_component_el_form_item, {
                    label: "缓存内容:",
                    prop: "cacheValue"
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_input, {
                      modelValue: _unref(cacheForm).cacheValue,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(cacheForm).cacheValue = $event),
                      type: "textarea",
                      rows: 8,
                      readOnly: true
                    }, null, 8, ["modelValue"])]),
                    _: 1
                  })]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            }, 8, ["model"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};